import * as React from "react";
import { forwardRef } from "react";
const SvgLink = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 12C2.79086 12 1 10.2091 1 8C1 5.79086 2.79086 4 5 4H6C8.20914 4 10 5.79086 10 8M6 8C6 10.2091 7.79086 12 10 12H11C13.2091 12 15 10.2091 15 8C15 5.79086 13.2091 4 11 4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgLink);
export default ForwardRef;
